import { render } from "./SDManager.vue?vue&type=template&id=06b22bba"
import script from "./SDManager.vue?vue&type=script&lang=js"
export * from "./SDManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__